<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [closeOnEscape]="true"
  (onShow)="docNameInput.focus()"
  (onHide)="close()"
  styleClass="pos-dlg pos-dlg-md premium-dialog doctor-management-custom-dialog"
  [focusOnShow]="false"
>
  <div class="premium-header">
    <div class="premium-header-content">
      <h3 class="premium-title">Doctor Management</h3>
      <p class="premium-subtitle">Add &amp; manage doctor / hospital details</p>
    </div>
    <button type="button" class="premium-close-btn" (click)="close()" aria-label="Close">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- Body Content -->
  <div class="doctor-form-body premium-body">
    <div class="row g-3">
      <!-- Doctor Name -->
      <div class="col-12 col-md-6">
        <label class="form-label" for="docName">
          Doctor Name <span class="text-danger">*</span>
        </label>
        <div class="input-with-icon">
          <i class="pi pi-user field-icon"></i>
          <input
            id="docName"
            #docNameInput
            type="text"
            pInputText
            [(ngModel)]="doctor.doctorName"
            placeholder="Enter doctor Name"
            class="form-control-custom w-100"
          />
        </div>
      </div>

      <!-- Registration Number -->
      <div class="col-12 col-md-6">
        <label class="form-label" for="regNumber">
          Registration Number
        </label>
        <div class="input-with-icon">
          <i class="pi pi-id-card field-icon"></i>
          <input
            id="regNumber"
            type="text"
            pInputText
            [(ngModel)]="doctor.registrationNumber"
            placeholder="Enter registration number"
            class="form-control-custom w-100"
          />
        </div>
      </div>

      <!-- Hospital / Clinic Name -->
      <div class="col-12 col-md-6">
        <label class="form-label" for="hospitalName">
          Hospital / Clinic Name
        </label>
        <div class="input-with-icon">
          <i class="pi pi-building field-icon"></i>
          <input
            id="hospitalName"
            type="text"
            pInputText
            [(ngModel)]="doctor.hospitalClinicName"
            placeholder="Enter Hospital / Clinic"
            class="form-control-custom w-100"
          />
        </div>
      </div>

      <!-- Doctor Mobile -->
      <div class="col-12 col-md-6">
        <label class="form-label" for="docMobile">
          Mobile Number
        </label>
        <div class="input-with-icon">
          <i class="pi pi-phone field-icon"></i>
          <input
            id="docMobile"
            type="text"
            pInputText
            [(ngModel)]="doctor.doctorMobile"
            placeholder="Enter mobile number"
            maxlength="10"
            class="form-control-custom w-100"
          />
        </div>
      </div>

      <!-- Address 1 -->
      <div class="col-12 col-md-6">
        <label class="form-label" for="address1">
          Address Line 1
        </label>
        <input
          id="address1"
          type="text"
          pInputText
          [(ngModel)]="doctor.address1"
          placeholder="Enter address line 1"
          class="form-control-custom w-100"
        />
      </div>

      <!-- Address 2 -->
      <div class="col-12 col-md-6">
        <label class="form-label" for="address2">
          Address Line 2
        </label>
        <input
          id="address2"
          type="text"
          pInputText
          [(ngModel)]="doctor.address2"
          placeholder="Enter address line 2"
          class="form-control-custom w-100"
        />
      </div>

      <!-- Country -->
      <div class="col-12 col-md-6">
        <label class="form-label">
          Country
        </label>
        <p-dropdown
          [options]="countries"
          [(ngModel)]="doctor.country"
          (onChange)="onCountryChange($event.value)"
          placeholder="Select Country"
          [filter]="true"
          filterBy="label"
          styleClass="w-100 custom-dropdown"
          appendTo="body"
        ></p-dropdown>
      </div>

      <!-- State -->
      <div class="col-12 col-md-6">
        <label class="form-label">
          State
        </label>
        <p-dropdown
          [options]="states"
          [(ngModel)]="doctor.state"
          (onChange)="onStateChange($event.value)"
          placeholder="Select State"
          [filter]="true"
          filterBy="label"
          [disabled]="!doctor.country"
          styleClass="w-100 custom-dropdown"
          appendTo="body"
        ></p-dropdown>
      </div>

      <!-- City -->
      <div class="col-12 col-md-6">
        <label class="form-label">
          City
        </label>
        <p-dropdown
          [options]="cities"
          [(ngModel)]="doctor.city"
          placeholder="Select City"
          [filter]="true"
          filterBy="label"
          [disabled]="!doctor.state"
          styleClass="w-100 custom-dropdown"
          appendTo="body"
        ></p-dropdown>
      </div>

      <!-- Pincode -->
      <div class="col-12 col-md-6">
        <label class="form-label" for="pincode">
          Pincode/zipcode
        </label>
        <input
          id="pincode"
          type="text"
          pInputText
          [(ngModel)]="doctor.pincode"
          placeholder="Enter pincode/zipcode"
          maxlength="10"
          class="form-control-custom w-100"
        />
      </div>
    </div>
  </div>

  <div class="premium-footer">
    <button type="button" class="premium-btn premium-btn-secondary" (click)="close()">
      Cancel
    </button>
    <button
      type="button"
      class="premium-btn premium-btn-primary"
      [disabled]="!doctor.doctorName.trim()"
      (click)="save()"
    >
      <i class="pi pi-check"></i>
      Add
    </button>
  </div>
</p-dialog>
